module.exports = ".row{\r\n    padding: 1em 0px 0px 0px !important;\r\n    margin-bottom: -10px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/planning/validatelandrecordlist/validatelandrecordlist.component.css
// module id = ./src/app/planning/validatelandrecordlist/validatelandrecordlist.component.css
// module chunks = main